import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import Add from '../components/Dashboard/Add';
import Profile from '../components/Dashboard/Profile';
import Users from '../components/Dashboard/Users';
import Forgot from '../components/Forgot';
import Home from "../components/Home";
import Login from "../components/Login";
import Signup from '../components/Signup';
import History from '../components/History';
import Report from '../components/Report';
import Terms from '../components/Terms';
import Privacy from '../components/Privacy';
import Alerts from '../components/Alerts';
import { useAuth } from "../context/AuthContext";
import Verification from '../components/Verification';
import DpTable from "../components/DpTable";
import DpPage from "../components/DP";
import DpHisPage from "../components/DpHis";


const PrivateRoutes = ({ role, component: Comp, ...rest }) => {
  return (
    <Route {...rest} component={(props) => role ? <Comp {...props} /> : <Redirect to="/login" />}/>
  );
};

const PublicRoutes = ({ user, component: Comp, ...rest }) => {
  return (
    <Route {...rest} component={(props) => rest.restricted ? (user ? (<Redirect to="/" />) : (<Comp {...props} />)) : (<Comp {...props} />)}/>
  );
};

const Routes = () => {
  const { isAuth,activeUser,user } = useAuth();
  // debugger;
  return (
    activeUser.role && !user.emailVerified ? 
    <Switch>
      <Route path="/" component={Verification} exact />
      {/* change to * for path not work for hexo blog */}
    </Switch> :
    <Switch>
      {/* <PublicRoutes restricted={false} user={isAuth} component={Users} path="/" exact /> */}
      <PublicRoutes restricted={false} user={isAuth} component={Home} path="/" exact />
      <PublicRoutes restricted={false} user={isAuth} component={Report} path="/report" exact />
      <PublicRoutes restricted={false} user={isAuth} component={Terms} path="/tos" exact />
      <PublicRoutes restricted={false} user={isAuth} component={Terms} path="/terms" exact />
      <PublicRoutes restricted={false} user={isAuth} component={Privacy} path="/privacy" exact />
      <PublicRoutes restricted={true} user={isAuth} component={Forgot} path="/forgot" exact />
      <PublicRoutes restricted={true} user={isAuth} component={Login} path="/login" exact />
      <PublicRoutes restricted={true} user={isAuth} component={Signup} path="/signup" exact />
      <PrivateRoutes
        role={activeUser ? activeUser.role : true}
        component={DpPage}
        path="/dp"
        exact
      />
      <PrivateRoutes
        role={activeUser ? activeUser.role : true}
        component={DpTable}
        path="/dptable"
        exact
      />
      <PublicRoutes
        role={activeUser ? activeUser.role : true}
        component={DpHisPage}
        path="/dphis/:ticket?"
        exact
      />
      <PrivateRoutes role={activeUser ? activeUser.role ==="admin" : false} component={Users} path="/users" exact />
      <PrivateRoutes role={activeUser ? activeUser.role : true} component={Dashboard} path="/realtime" exact />
      <PrivateRoutes role={activeUser ? activeUser.role : true} component={Dashboard} path="/dashboard" exact />
      <PrivateRoutes role={activeUser ? activeUser.role : true} component={History} path="/database" exact />
      <PrivateRoutes role={activeUser ? activeUser.role : true} component={Profile} path="/profile" exact />
      <PrivateRoutes role={activeUser ? activeUser.role : true} component={Add} path="/panel/add/tables" exact />
      <PrivateRoutes role={activeUser ? activeUser.role : true} component={Add} path="/panel/edit/tables/:id" exact />
      <PrivateRoutes role={activeUser ? activeUser.role : true} component={Alerts} path="/alerts" exact />
    </Switch>
  );
};

export default Routes;